import { render } from "./SkillsWidget.vue?vue&type=template&id=5997c52c"
import script from "./SkillsWidget.vue?vue&type=script&lang=js"
export * from "./SkillsWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__